exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-category[data-v-6c0da89c]{\n   display: inline-block;\n   margin-left: 30px;\n}\n.home-layout img[data-v-6c0da89c] {\n    width: 100%;\n    border: 2px solid #000;\n    border-radius: 2%;\n    margin-top: 10px;\n}\n", ""]);

// exports
